import OrderStatus from "@/enum/OrderStatus";
import OrderStatusNameMap from "@/map/OrderStatusNameMap";
import { OrderExportFieldsStatus } from "@/services/api/moreFeatures/orderExport";
import OrderExportField from "@/services/api/moreFeatures/orderExport/enum/Fields";

export const orderStatusArray = Object.entries(OrderStatusNameMap)
    .filter(([key]) => key !== OrderStatus.PENDING_PAYMENT)
    .map(([value, label]) => ({ value, label }));

export const productFieldValueArray = [
    OrderExportField.PRODUCT_TITLE,
    OrderExportField.EXTERNAL_ID,
    OrderExportField.SKU_PROPERTIES,
    OrderExportField.PRODUCT_QUANTITY,
    OrderExportField.PRODUCT_PRICE,
    OrderExportField.PRODUCT_WEIGHT,
    OrderExportField.PRODUCT_REFUNDING,
    OrderExportField.PRODUCT_STOCK_NO,
    OrderExportField.AFFILIATE_MARKETER,
    OrderExportField.PRODUCT_ORIGINAL_ID,
    OrderExportField.SKU_ORIGINAL_ID,
];

/**
 * 默认顺序列表
 * 包含所有可能的字段
 */
export const defaultOrderExportFields: OrderExportField[] = [
    OrderExportField.SHOP_NAME,
    OrderExportField.ORDER_STATUS,
    OrderExportField.AMOUNTS,
    OrderExportField.BUYER_REMARKS,
    OrderExportField.BUYER_USERNAME,
    OrderExportField.CITY,
    OrderExportField.COD_AMOUNTS,
    OrderExportField.CONSIGNEE_NAME,
    OrderExportField.DETAILED_ADDRESS,
    OrderExportField.DISCOUNTS,
    OrderExportField.DISTRICT,
    OrderExportField.END_TIME,
    OrderExportField.EXTERNAL_ID,
    OrderExportField.FLAG,
    OrderExportField.ORDER_MARK,
    OrderExportField.LOGISTICS_COMPANY,
    OrderExportField.MOBILE,
    OrderExportField.ORDER_TIME,
    OrderExportField.ORIGINAL_ID,
    OrderExportField.PAYMENTS,
    OrderExportField.SELLER_RECEIPTS,
    OrderExportField.PAYMENT_TIME,
    OrderExportField.PRODUCT_ORIGINAL_ID,
    OrderExportField.PRODUCT_PRICE,
    OrderExportField.ORDER_ITEM_COST,
    OrderExportField.PRODUCT_QUANTITY,
    OrderExportField.PRODUCT_REFUNDING,
    OrderExportField.PRODUCT_STOCK_NO,
    OrderExportField.PRODUCT_TITLE,
    OrderExportField.PRODUCT_RAW_TITLE,
    OrderExportField.PRODUCT_SIMPLE_TITLE,
    OrderExportField.PRODUCT_WEIGHT,
    OrderExportField.PROVINCE,
    OrderExportField.SELLER_REMARKS,
    OrderExportField.SHIPPING_COST,
    OrderExportField.SHIPPING_TIME,
    OrderExportField.SKU_ORIGINAL_ID,
    OrderExportField.SKU_PROPERTIES,
    OrderExportField.STREET,
    OrderExportField.TELEPHONE,
    OrderExportField.WAYBILL_NO,
    OrderExportField.WEIGHT,
    OrderExportField.ZIP_CODE,
    OrderExportField.SUPPLIER_NAME,
    OrderExportField.RETAILER_NAME,
    OrderExportField.SEQUENCE_NO,
    OrderExportField.AFFILIATE_MARKETER,
    OrderExportField.SHIPPER_NAME,
    OrderExportField.SUPPLIER_REMARKS,
    OrderExportField.WAYBILL_PRINT_TIME,
];

export function completeExportFields(savedStatuses: OrderExportFieldsStatus[] = []) {
    const saveFields = savedStatuses.map(({ field }) => field);
    // 创建字段标识符的Set用于快速查找
    const savedFieldSet = new Set(saveFields);

    // 筛选出缺失的字段（存在于allFields但不在savedFields中）
    const missingStatuses = defaultOrderExportFields.filter((field) => !savedFieldSet.has(field));

    // 返回合并后的列表（原有字段 + 新增的缺失字段）
    return [...saveFields, ...missingStatuses];
}
